export default function useAllocationModelChartData({ managedAccount }) {
  const classifications = managedAccount?.attr('allocationModelChartData').resources().list().map(classification => ({
    type: classification.id(),
    name: classification.attr('label'),
    value: parseFloat(classification.attr('value')),
    color: classification.attr('color'),
  }));

  return {
    classifications,
  };
}
